export default __webpack_public_path__ + "static/media/Paymode.ca1a1d14.xlsx";